var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "task-drawer" } },
    [
      _c(
        "a-drawer",
        {
          attrs: {
            visible: true,
            title: _vm.$t("calendar.tasks"),
            placement: "right",
          },
          on: {
            close: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        _vm._l(_vm.tasks, function (task) {
          return _c(
            "div",
            { key: task._id, staticClass: "task-item" },
            [
              _c("a-radio", {
                on: {
                  change: function ($event) {
                    return _vm.markCompleted(task._id)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "info-title" }, [
                  _vm._v(_vm._s(task.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-description" }, [
                  _vm._v(_vm._s(task.description)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-time" }, [
                  _c("div", { staticClass: "info-time-item" }, [
                    _vm._v(_vm._s(_vm.getDateFormat(task.startDate))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-time-item" }, [
                    _vm._v(_vm._s(_vm.getTimeFormat(task.startTime))),
                  ]),
                ]),
              ]),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }